export const LESSON_STATUS = {
  COMPLETED: "completed",
  INCOMPLETE: "incomplete",
};
